import React from 'react';
import { Chip } from '@mui/material';

function ServicesChip(props) {
  const { clickAction } = props;

  return (
    <Chip
      label="Unpublished"
      size="small"
      variant="outlined"
      onClick={() => {
        if (clickAction) {
          clickAction();
        }
      }}
      // clickable false to prevent default behavior
      clickable={false}
      sx={{
        color: '#232B35',
        backgroundColor: '#FBCFD5',
        border: 'none',
        height: '32px',
        padding: '0px 12px',
        marginLeft: '-14px',
        cursor: 'pointer',
        width: 'fit-content',
      }}
    />
  );
}

export default ServicesChip;
